import { Link, useNavigate, useLocation } from 'react-router-dom';
import Headroom from 'react-headroom';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';
import { updateSettings } from '../redux/settingsSlice';
import ProfileToolbar from './ProfileToolbar';
import BotToolbar from './BotToolbar';
import OutwriteToolbar from './OutwriteToolbar';

const Header = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(updateSettings([]));
    navigate('/login');
  };

  const buttons = [];

  const aboutButton = {
    label: 'About',
    size: 'large',
    to: '/about',
    style: { backgroundColor: '#e6f2ff', color: '#4a90e2' },
  };

  if (!user) {
    buttons.push({ label: 'Login', to: '/login', color: 'secondary' });
  } else {
    if (user.type === 'superuser') {
      buttons.push({ label: 'Users', to: '/users', color: 'success' });
    } else if (user.type === 'admin') {
      buttons.push({ label: 'Register', to: '/register', color: 'success' });
    } else if (user.type === 'teacher') {
      buttons.push({ label: 'Summary', to: '/teacher/summary', color: 'info' });
      buttons.push({ label: 'Schedule', to: '/teacher/schedule', color: 'info' });
      buttons.push({ label: 'Students', to: '/students', color: 'info' });
      buttons.push({ label: 'Billing', to: '/billing', color: 'info' });
      buttons.push({ label: 'Lessons', to: '/teacher/lessons', color: 'info' });
    } else if (user.type === 'student') {
      buttons.push({ label: 'Summary', to: '/student/summary', color: 'info' });
      buttons.push({ label: 'Schedule', to: '/student/schedule', color: 'info' });
      buttons.push({ label: 'Teachers', to: '/teachers', color: 'info' });
      buttons.push({ label: 'Lessons', to: '/student/lessons', color: 'info' });
    } else if (user.type === 'outwrite_learner') {
      buttons.push({ label: 'Practice', to: '/outwrite/learn', color: 'info' });
    }

    buttons.push(aboutButton);
  }

  const isActive = (button) => {
    if (!button.to) return false;
    if (button.to === '/outwrite/learn') {
      return location.pathname === button.to
        || location.pathname.startsWith('/outwrite/learn/');
    }
    return location.pathname === button.to;
  };

  return (
    <Headroom>
      <header style={{ padding: '10px 20px', backgroundColor: '#4A90E2', color: 'white' }}>
        <h1 style={{ margin: 0 }}>
          Key To English{' '}
          {user
            ? `[${user.firstName} ${user.lastName}] (${user.type})`
            : '[anonymous]'}
        </h1>

        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{ marginTop: '10px', width: '100%' }}
        >
          <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" useFlexGap>
            {buttons.map((button, index) => {
              const active = isActive(button);

              return (
                <Button
                  key={index}
                  variant="contained"
                  color={active ? 'warning' : button.color}
                  size={button.size}
                  style={button.style}
                  component={button.to ? Link : 'button'}
                  to={button.to}
                  onClick={button.onClick ? button.onClick : undefined}
                >
                  {button.label}
                </Button>
              );
            })}
          </Stack>

          {user && (
            <Stack direction="row" spacing={0} alignItems="center">
              {user.type === 'teacher' && <BotToolbar />}
              {user.type === 'outwrite' && <OutwriteToolbar />}
              <ProfileToolbar user={user} onLogout={handleLogout} />
            </Stack>
          )}
        </Stack>
      </header>
    </Headroom>
  );
};

export default Header;
